import { MembershipTierModel, type MembershipTier } from '@/http/models/PosCatalog'

import { Badge } from '@/components/ui/badge'

import { ResourcePage } from '@/components/features/pos/ResourcePage'

const MembershipTiers = () => (
  <ResourcePage<MembershipTier>
    title="Membership tiers"
    description="Reward-point levels and the discount each one gives."
    noun="tier"
    api={MembershipTierModel}
    permissions={{ create: 'membership_tiers:create', update: 'membership_tiers:update', delete: 'membership_tiers:delete' }}
    searchPlaceholder="Search by name"
    deleteDescription="This deletes the tier permanently."
    columns={[
      { label: 'Name', render: (t) => <span className="font-medium text-ink">{t.name}</span> },
      { label: 'From points', render: (t) => <span className="tabular-nums">{t.min_points}</span>, className: 'text-right' },
      { label: 'Discount', render: (t) => <span className="tabular-nums">{t.discount_percentage ?? 0}%</span>, className: 'text-right' },
      { label: 'Status', render: (t) => <Badge tone={t.status === 'active' ? 'success' : 'soft'}>{t.status === 'active' ? 'Active' : 'Inactive'}</Badge> },
    ]}
    fields={[
      { name: 'name', label: 'Name', type: 'text', required: true, placeholder: 'Gold' },
      { name: 'min_points', label: 'From points', type: 'number', required: true, min: 0 },
      { name: 'discount_percentage', label: 'Discount (%)', type: 'number', min: 0, max: 100 },
      { name: 'status', label: 'Active', type: 'status' },
    ]}
    toForm={(t) => ({
      name: t?.name ?? '',
      min_points: t ? String(t.min_points) : '0',
      discount_percentage: t ? String(t.discount_percentage ?? 0) : '0',
      status: (t?.status ?? 'active') === 'active',
    })}
  />
)

export default MembershipTiers
